import React from 'react';
import { convertIcon } from '../component/Icon';
interface OverrideIconSize24 {
  size: '24';
}
type OverrideIconSize = OverrideIconSize24;

const SvgComponent = ({
  size,
  color = '#616161',
  ...rest
}: React.SVGProps<SVGSVGElement> & OverrideIconSize) => {
  if (size === '24') {
    return (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.1625 2.10403C13.0756 2.03705 12.9684 2 12.8571 2H6.35714L6.20121 2.00535C4.96465 2.09057 4 3.18214 4 4.5V18.5L4.00705 18.6943C4.05388 19.3376 4.33189 19.9313 4.78189 20.3602C5.21032 20.7685 5.76658 21 6.35714 21H9.5L9.58988 20.9919C9.82312 20.9496 10 20.7455 10 20.5C10 20.2239 9.77614 20 9.5 20H6.35714L6.21754 19.9921C5.94106 19.9609 5.68257 19.8371 5.47181 19.6363C5.17504 19.3534 5 18.9439 5 18.5V4.5L5.0063 4.3543C5.07293 3.58786 5.65981 3 6.35714 3H12V7.4L12.006 7.54414C12.0739 8.35206 12.707 9 13.5 9H17V11.5L17.0081 11.5899C17.0504 11.8231 17.2545 12 17.5 12C17.7761 12 18 11.7761 18 11.5V7.5L17.9912 7.4066C17.9738 7.31484 17.9308 7.22914 17.8664 7.15977L13.2235 2.15977L13.1625 2.10403ZM12 15.5C12 15.2239 11.7761 15 11.5 15H7.5C7.22386 15 7 15.2239 7 15.5C7 15.7761 7.22386 16 7.5 16H11.5C11.7761 16 12 15.7761 12 15.5ZM14.5 12C14.7761 12 15 12.2239 15 12.5C15 12.7761 14.7761 13 14.5 13H7.5C7.22386 13 7 12.7761 7 12.5C7 12.2239 7.22386 12 7.5 12H14.5ZM11 9.5C11 9.22386 10.7761 9 10.5 9H7.5C7.22386 9 7 9.22386 7 9.5C7 9.77614 7.22386 10 7.5 10H10.5C10.7761 10 11 9.77614 11 9.5ZM13 3.389V7.4C13 7.7073 13.1904 7.94746 13.4216 7.99242L13.5 8H17V7.697L13 3.389ZM20 14.5C20 14.2239 19.7761 14 19.5 14H16.5C16.2239 14 16 14.2239 16 14.5C16 14.7761 16.2239 15 16.5 15H18.292L13 20.292V18.5C13 18.2239 12.7761 18 12.5 18C12.2239 18 12 18.2239 12 18.5V21.5C12 21.7761 12.2239 22 12.5 22H15.5C15.7761 22 16 21.7761 16 21.5C16 21.2239 15.7761 21 15.5 21L13.707 20.999L19 15.706V17.5C19 17.7761 19.2239 18 19.5 18C19.7761 18 20 17.7761 20 17.5V14.5Z"
          fill={color}
        />
      </svg>
    );
  }
  return <div></div>;
};
/**
 * 컬러 주입 가능여부: 가능,
 * 기본컬러:#616161
 * 사용가능한 사이즈는 24 입니다.
 * 20(디폴트)사이즈가 없으므로 size prop은 required 입니다.
 */
const IconComponent = convertIcon<OverrideIconSize>(SvgComponent, 'fileEnlarger');
export default IconComponent;
